import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';

import * as styles from './styles';

const FormSteps = ({ activeIndex, steps }) => (
  <styles.Steps>
    {steps.map(({ name }, index) => {
      const isActive = index === activeIndex;
      const isComplete = index < activeIndex;
      const stepNumber = index + 1;

      return (
        <styles.Step
          isActive={isActive}
          isComplete={isComplete}
          key={`step-${name}`}
        >
          <styles.StepNumber isActive={isActive} isComplete={isComplete}>
            {stepNumber}
          </styles.StepNumber>
          <styles.StepName isActive={isActive}>{name}</styles.StepName>
        </styles.Step>
      );
    })}
  </styles.Steps>
);

FormSteps.propTypes = {
  steps: arrayOf(
    shape({
      name: string.isRequired
    })
  ).isRequired,
  activeIndex: number
};

FormSteps.defaultProps = {
  activeIndex: 0
};

export default FormSteps;
